import { ApiClientReturnType } from '~/types';
import apiClient from '../../api/http-common';

const getMilkFixedPriceList = (): any =>
  apiClient.post('/stock-exchange/trading-slots/list')

const milkFixedPriceExport = (): any =>
  apiClient.post('/stock-exchange/trading-slots/export')

const getMilkFixedPriceIndex = (data?): any => {
  return apiClient.post<IMilkFixedPriceData>('/stock-exchange/trading-slots/index', data)
}

const getMilkFixedPriceIndexData = (): any =>
  apiClient.post('/stock-exchange/trading-slots/get-index-data')

const countActiveTradingSlots = (): any =>
  apiClient.post('/stock-exchange/trading-slots/count-active')

const exportTradingSlots = () =>
  apiClient.post('/stock-exchange/trading-slots/export')

const getMilkFixedPriceOptions = (): any =>
  apiClient.post('/stock-exchange/trading-slots/get-options-data')

const countTradingSlots = (data?): any =>
  apiClient.post('/stock-exchange/trading-slots/count', data)

const createTradingSlot = (data): any =>
  apiClient.post('/stock-exchange/trading-slots/store', data)

const editTradingSlot = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/edit`)

const getFileTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/get-file`, data)

const deleteFileTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/delete-file`, data)

const farmersTradingSlot = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmers`, data)

const updateTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/update`, data)

const getTradingSlotMonths = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/get-trading-months`, data)

// Show Trading slot

const showTradingSlot = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/show`)

const showTradingSlotDaysUpdate = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/trading-days/update`, data)

const showTradingSlotFarmerData = (id: string, idFarmer: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmer-groups/${idFarmer}/get-data`)

const showTradingSlotFarmerDataMonths = (id: string, idFarmer: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmer-groups/${idFarmer}/trading-months`)

const updateShowTradingSlotFarmerDataMonths = (id: string, idFarmer: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmer-groups/${idFarmer}/trading-months/update`, data)

const planTradingSlot = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/plan`, data)

const notifyFarmersTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/notify/get-recipients`, data)

const notifyFarmers = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/notify`, data)

const summaryTradingSlot = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/summary/pdf`)

const offerPdfTradingSlot = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers-overview/pdf`)

const showTradingSlotExport = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/export`)

const abortTradingSlot = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/abort`, data)

const getFile = (id: string, idFarmer: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmer-groups/${idFarmer}/get-file`, data)

// Offers Preview Trading slot

const offersPreviewTradingSlot = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers-preview`, data)

const exportShowFarmer = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/export`)

const saveOffersPreviewTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/save`, data)

const confirmOffersPreviewTradingSlot = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/confirm`, data)

const getOffersPreviewTradingSlot = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/get-offers`, data)

const offersPreviewTradingSlotOptions = (id: string): ApiClientReturnType<OffersPreviewSettType> =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/get-settings-data`)

const offersPreviewTradingSlotByMonths = (id: string, farmerGroupId: string): ApiClientReturnType<OfferMontsType[]> =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/get-months`, { farmerGroupId })

const deleteTradingOffer = (tradingSlotId: string, offerId: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${tradingSlotId}/confirm-offers/${offerId}/delete`)

// Farmer Offers Preview Trading slot Farmer
const farmerOfferAmountsSettings = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offer/get-settings-data`)

const getTradingSlotsFarmerSettings = (): any =>
  apiClient.post('/stock-exchange/trading-slots/get-settings-data')

const farmerOfferAmountsList = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offer/get-months`)

const saveFarmerOfferAmountsList = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offer/save`, data)

const getTradingActivities = (data?): any =>
  apiClient.post('/stock-exchange/trading-slots/offers/index', data)

const offersStatusOptions = (): any =>
  apiClient.post('/stock-exchange/trading-slots/offers/get-index-data')

const getPreviewOffers = (id: string, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/index`, data)

const abortTradingSlotOffer = (id: string, offerId, data?): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/${offerId}/abort`, data)

const abortTradingSlotOfferData = (id: string, offerId): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/${offerId}/get-abort-data`)

const getChangeAmountData = (id: string, offerId): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/${offerId}/get-change-data`)

const changeAmountData = (id: string, offerId, data: any): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/offers/${offerId}/change`, data)

const getOffersData = (id: string, farmerGroupId, data: any): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/farmer-groups/${farmerGroupId}/offers/index`, data)

const acceptTradingRooms = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/accept-trading-terms`)

const openTradingRoomFile = (data): any =>
  apiClient.post('/stock-exchange/trading-slots/get-trading-room-file', data)

const checkTradingRoomsAccept = (id: string): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/terms-accepted`)

const updateBLEPrice = (id: string, data): any =>
  apiClient.post(`/stock-exchange/trading-slots/${id}/confirm-offers/update-price`, data)

const getStoneXContracts = (data?): any =>
  apiClient.post('/ble-contracts/index', data)

const storeStoneXContract = (data): any =>
  apiClient.post('/ble-contracts/store', data)

const updateStoneXContract = (id: string, data): any =>
  apiClient.post(`/ble-contracts/${id}/update`, data)

const getStoneXContract = (id: string): any =>
  apiClient.post(`/ble-contracts/${id}/edit`)

const getStoneXContractsOptions = (data?): any =>
  apiClient.post('/ble-contracts/get-options-data', data)

const getStoneXContractDetails = (id: string): any =>
  apiClient.post(`/ble-contracts/${id}/details`)

const deleteStoneXContract = (id: string): any =>
  apiClient.post(`/ble-contracts/${id}/delete`)

const StockExChangeService = {
  getMilkFixedPriceList,
  milkFixedPriceExport,
  getMilkFixedPriceIndex,
  getMilkFixedPriceIndexData,
  getMilkFixedPriceOptions,
  createTradingSlot,
  showTradingSlot,
  countTradingSlots,
  showTradingSlotFarmerData,
  showTradingSlotFarmerDataMonths,
  offersPreviewTradingSlot,
  offersPreviewTradingSlotOptions,
  showTradingSlotDaysUpdate,
  updateShowTradingSlotFarmerDataMonths,
  planTradingSlot,
  offersPreviewTradingSlotByMonths,
  showTradingSlotExport,
  farmerOfferAmountsSettings,
  farmerOfferAmountsList,
  saveFarmerOfferAmountsList,
  saveOffersPreviewTradingSlot,
  confirmOffersPreviewTradingSlot,
  getOffersPreviewTradingSlot,
  summaryTradingSlot,
  offerPdfTradingSlot,
  abortTradingSlot,
  editTradingSlot,
  updateTradingSlot,
  getTradingActivities,
  getPreviewOffers,
  farmersTradingSlot,
  exportTradingSlots,
  getTradingSlotMonths,
  notifyFarmersTradingSlot,
  notifyFarmers,
  offersStatusOptions,
  exportShowFarmer,
  getTradingSlotsFarmerSettings,
  getFile,
  abortTradingSlotOffer,
  getChangeAmountData,
  changeAmountData,
  acceptTradingRooms,
  openTradingRoomFile,
  getFileTradingSlot,
  deleteFileTradingSlot,
  countActiveTradingSlots,
  deleteTradingOffer,
  abortTradingSlotOfferData,
  checkTradingRoomsAccept,
  getOffersData,
  updateBLEPrice,
  getStoneXContracts,
  getStoneXContractsOptions,
  getStoneXContract,
  storeStoneXContract,
  updateStoneXContract,
  getStoneXContractDetails,
  deleteStoneXContract
}

export interface IMilkFixedPriceData {
  data: {
    filtered: number;
    rows: any[];
    total: number;
  }
}

export interface OfferMontsType {
  price: string;
  date: Date;
  offeredAmount: string;
  confirmedAmount: string;
  total: string;
}

export interface OffersPreviewSettType {
  operativeUsersCanSeeFarmersInfo: number;
  farmerGroups: FarmerGroup[];
  months: Month[];
  status: string;
  confirmAvailable: boolean;
  offerDeleteAvailable: boolean;
}

export interface FarmerGroup {
  id: string;
  name: string;
}

export interface Month {
  date: Date;
  label: string;
}

export default StockExChangeService
